import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selected, setSelected] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelected(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            Browse Products
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Use the dropdown below to jump directly to any product category on our main platform. Thousands of curated items await.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-12">
          <div className="relative">
            <select
              value={selected}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-background-100 border border-background-300/60 rounded-lg px-5 py-3.5 text-sm text-foreground-800 font-medium focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all pr-12"
            >
              <option value="">— Select a Category —</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 rounded-lg overflow-hidden transition-all duration-200"
            >
              <div className="relative h-36 md:h-40 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Sugargoo Spreadsheet ${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`Sugargoo Spreadsheet - ${cat.name}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-50/90 backdrop-blur-sm flex-shrink-0">
                      <i className={`${cat.icon} text-foreground-700 text-xs`}></i>
                    </div>
                    <span className="text-xs md:text-sm font-semibold text-background-50 group-hover:text-primary-100 leading-tight">
                      {cat.name}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}